import { ChangeDetectorRef, Directive, ViewContainerRef } from '@angular/core';
import { DynamicContentService } from './dynamic-content.service';

@Directive({
    standalone: true,
    selector: '[appSetAsDynamicContainer]'
})
export class SetAsDynamicContainerDirective {
    constructor(
        private readonly dynamicContentService: DynamicContentService,
        private readonly viewContainerRef: ViewContainerRef,
        private readonly changeDetectorRef: ChangeDetectorRef
    ) {
        this.dynamicContentService.setViewRefAndChangeDetectorRef(viewContainerRef, changeDetectorRef);
    }
}
